import { gql } from '../../__generated__/gql'

export const COMMUNITY_TOP_QUESTION_QUERY = gql(`
  query communityTopQuestion {
    communityTopQuestion {
      id
      title
      category {
        id
      }
    }
  }
`)
